import { ChevronUp, Table2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface FloatingPanelToggleProps {
  isOpen: boolean;
  onClick: () => void;
  tagCount: number;
}

export function FloatingPanelToggle({
  isOpen,
  onClick,
  tagCount,
}: FloatingPanelToggleProps) {
  return (
    <button
      onClick={onClick}
      tabIndex={isOpen ? -1 : 0}
      aria-hidden={isOpen}
      className={cn(
        "fixed bottom-4 right-4 z-50 flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow-lg transition-all hover:bg-primary/90 hover:shadow-xl",
        isOpen && "translate-y-20 opacity-0 pointer-events-none"
      )}
    >
      <Table2 className="size-4" />
      <span>Tag Results</span>
      {tagCount > 0 && (
        <span className="ml-1 rounded-full bg-primary-foreground/20 px-2 py-0.5 text-xs">
          {tagCount}
        </span>
      )}
      <ChevronUp className="size-4" />
    </button>
  );
}
